import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import './Radio.css';
import { RadioSnippet } from '../../snippets/RadioSnippet/RadioSnippet'
import Card from '../Card/Card';
import { Copy } from 'lucide-react';
const Radio = () => {
  const snippetContainerRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);

  const copySnippet = () => {
    if (snippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(snippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };
  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className="radio-field">
        <input type="radio" name="one" id="radioOne" />
        <label htmlFor="radioOne">option A</label>
      </div>
      <div className="radio-field">
        <input type="radio" name="one" id="radioTwo" />
        <label htmlFor="radioTwo">Option B</label>
      </div>
      <div className="radio-field">
        <input type="radio" name="one" id="radioThree" />
        <label htmlFor="radioThree">option C</label>
      </div>
      <div className="radio-field">
        <input type="radio" name="one" id="radioFour" />
        <label htmlFor="radioFour">Option D</label>
      </div>
      <div className={`center-container ${showScanning ? 'scanning' : ''}`}>

        <div className='snippet' ref={snippetContainerRef}>
          <RadioSnippet />
        </div>
        <button aria-label="Copy Button" onClick={copySnippet}>
          <Copy />
        </button>

      </div>
    </motion.div>
  );
}
const RadioCard = () => {
  return (
    <Card
      CardTitle='Radio'
      CardBody={<Radio />}
    />
  );
}
export default RadioCard;